import { createAsyncThunk } from "@reduxjs/toolkit"
import { CoreState } from "../state/core.state"
import { coreActions } from "../slices/core.slice"
import { authorizedGet } from "../utils/api"
import { identifyUserInAnalytics } from "../utils/analytics"
import { findTenantId, hideShellLoader, navigateTo401 } from "../utils/dom"
import {
  GLOBAL_TENANT_HINT,
  SUPER_ADMIN_TENANT_ID
} from "../constants/tenant"
import { appLogout } from "./auth.thunks"
import { getAppConfig } from "./config.thunks"
import { getPendingEulas } from "./eula.thunks"
import { setApplicationMessages } from "./messages.thunks"

export const fetchUserInfo = createAsyncThunk<
  void,
  any,
  { state: CoreState }
>(
  "core/fetchUserInfo",
  async (_arg, { getState, dispatch }) => {
    const userToken = getState().userToken
    try {
      const res = await authorizedGet("/platform/userinfo", userToken)

      if (res.error) {
        console.error("DEBUG: Error fetching user info:", res.error)
        dispatch(appLogout(undefined))
        dispatch(coreActions.setLoaderStatus(false))
        return
      }

      const userResponse = { ...res }
      if (userResponse.scope === "") {
        navigateTo401({ dispatch })
        // navigateToUrl doesn't stop execution — without this return the
        // thunk kept booting the app (EULAs, app config, menus) on top of
        // the 401 route.
        return
      }

      const gtenantId = findTenantId(
        userResponse?.ext?.tenantId,
        GLOBAL_TENANT_HINT
      )
      const isEmulated = sessionStorage.getItem("isEmulated")
      const isSuperAdmin = gtenantId === SUPER_ADMIN_TENANT_ID
      const hasEulaSearchScope =
        userResponse?.scope?.includes("eula.search") ||
        userResponse?.scope?.includes("eula:search")
      const isNotEmulated = isEmulated !== "true"

      if (hasEulaSearchScope && !isSuperAdmin && isNotEmulated) {
        dispatch(getPendingEulas({ payload: { userToken, userResponse } }))
      } else if ((isSuperAdmin && isNotEmulated) || isEmulated === "true") {
        dispatch(coreActions.setUserInfo(userResponse))
        dispatch(getAppConfig(undefined))
      } else {
        dispatch(coreActions.setUserInfo(userResponse))
        dispatch(coreActions.setLoaderStatus(false))
        hideShellLoader()
      }

      identifyUserInAnalytics(userResponse)
      dispatch(setApplicationMessages({ language: "en-us" }))
    } catch (err) {
      console.error("DEBUG: userinfo error:", err)
      dispatch(appLogout(undefined))
      dispatch(coreActions.setLoaderStatus(false))
    }
  }
)
